import { FC, useContext, useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import {
  ADMIN_SIDEBAR_MENU_ITEMS,
  LOGOUT_SIDEBAR_MENU_ITEM,
  PATIENT_SIDEBAR_MENU_ITEMS,
  PRACTITIONER_SIDEBAR_MENU_ITEMS,
  RECEPTIONIST_SIDEBAR_MENU_ITEMS,
  SUPER_ADMIN_SIDEBAR_MENU_ITEMS,
  getPractitionerMenuItems,
} from "./menus";
import FlexBox from "../../common/flex-box";
import IconBox from "../../common/icon-box";
import { AppContext } from "lib/contexts/app-context";

interface SideBarItemElementProps {
  item: GeneralItem;
  isSelected: boolean;
  onClick: () => void;
  isCollapsed: boolean;
}
const SideBarItemElement: FC<SideBarItemElementProps> = ({
  isCollapsed = false,
  item,
  isSelected,
  onClick,
}) => {

  const handleClick = () => {
    if (!item.disabled) {
      onClick();
    }
  };

  if (isCollapsed) {
    return (
      <FlexBox
        justifyContent="start"
        alignItems="center"
        className={`px-3 py-2 sidebar-item ${isSelected && "selected"} ${item.disabled ? "disabled" : ""}`}
        onClick={handleClick}
      >
        <IconBox icon={item.icon} />
      </FlexBox>
    );
  }

  return (
    <FlexBox
      justifyContent="start"
      alignItems="center"
      className={`px-3 py-2 sidebar-item ${isSelected && "selected"} ${item.disabled ? "disabled" : ""}`}
      onClick={handleClick}
    >
      <IconBox icon={item.icon} />
      <div className="sidebar-text">{item.label}</div>
    </FlexBox>
  );
};

interface SideBarProps {
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
}

const SideBar: FC<SideBarProps> = ({ isCollapsed, setIsCollapsed }) => {
  const { appState } = useContext(AppContext);
  const navigateTo = useNavigate();
  const location = useLocation();

  const [menuItems, setMenuItems] = useState<GeneralItem[]>(
    PATIENT_SIDEBAR_MENU_ITEMS
  );

  const handleMenuItemClick = (item: GeneralItem): void => {
    if (item.href) {
      navigateTo(item.href);
      setIsCollapsed(true)
    }
  };

  useEffect(() => {
    switch (appState.userRole) {
      case "admin":
        setMenuItems(ADMIN_SIDEBAR_MENU_ITEMS);
        break;
      case "super":
        setMenuItems(SUPER_ADMIN_SIDEBAR_MENU_ITEMS);
        break;
      case "practitioner":
        setMenuItems(getPractitionerMenuItems(appState));
        break;
      case "receptionist":
        setMenuItems(RECEPTIONIST_SIDEBAR_MENU_ITEMS);
        break;
      default:
        setMenuItems(PATIENT_SIDEBAR_MENU_ITEMS);
    }
  }, [appState.userRole]);

  return (
    <div className={`sidebar shadow z-3 ${isCollapsed ? "collapsed" : ""}`}>
      <FlexBox
        justifyContent="between"
        alignItems="start"
        className="sidebar-wrapper"
        direction="column"
      >
        <FlexBox
          justifyContent="start"
          alignItems="start"
          direction="column"
          className="w-100"
        >
          {menuItems.map((item) => (
            <SideBarItemElement
              key={item.id}
              item={item}
              isCollapsed={isCollapsed}
              onClick={() => handleMenuItemClick(item)}
              isSelected={location.pathname.includes(item.href)}
            />
          ))}
        </FlexBox>
        <SideBarItemElement
          item={LOGOUT_SIDEBAR_MENU_ITEM}
          isCollapsed={false}
          onClick={() => handleMenuItemClick(LOGOUT_SIDEBAR_MENU_ITEM)}
          isSelected={false}
        />
      </FlexBox>
    </div>
  );
};

export default SideBar;
